import { Button, Form, FormInstance, Modal, Select } from 'antd';
import { useWatch } from 'antd/es/form/Form';
import TextArea from 'antd/es/input/TextArea';
import { FormProps } from 'antd/lib';
import dayjs from 'dayjs';
import customParseFormat from "dayjs/plugin/customParseFormat";
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Layout from '../../Layout';
import { getInfoVoucher, IVoucherEdit, updateStatusVoucher } from '../../api/voucher/voucherApi';
import BreadcrumbBlock from '../../components/BreadcrumbBlock/BreadcrumbBlock';
import VoucherDetailCard from '../../components/Cards/VoucherDetailCard';
import useLoading from '../../hook/useLoading';
import useThrottle from '../../hook/useThrottle';
import useToast from '../../hook/useToast';
import { useVoucherDetail } from '../../hook/useVoucherDetail';
import { FIELDTYPE, VoucherAction, VoucherDetailStatusEnum } from '../../services/data';
import { selectorPermission } from '../../store/slices/permissionSlice';
import { fommatSelectOptionTitle, formatDateToDMYGroup, getUserPermissions } from '../../until';
import VoucherDetailTable from './VoucherComponents/VoucherDetailTable';
import './VoucherDetail.scss';
import { getCLTypeVoucher } from '../../api/selectOption/selectOptionsApi';



dayjs.extend(customParseFormat);

type FieldType = {
  customerName?: string;
  shopId?: string;
  date?: string;
}



const VoucherDetail: React.FC = () => {

  useEffect(() => {

    return (() => {
      setInfoVoucher(undefined)
    })

  }, []);
  const location = useLocation()

  const permissionSlice = useSelector(selectorPermission)

  const { approve } = getUserPermissions(permissionSlice, location.pathname)

  const { id, firstPage, idCustomer } = location?.state ?? {}
  const navigate = useNavigate()
  const pushToast = useToast();
  const pushLoading = useLoading()



  const [form] = Form.useForm();
  const state = useWatch('state', form)
  const formRef = useRef<FormInstance<FIELDTYPE>>(null);

  const [isModalShow, setModalShow] = useState(false)
  const [confirmLoading, setConfirmLoading] = useState(false)


  const [infoVoucher, setInfoVoucher] = useState<IVoucherEdit>()
  const [sLTypeVoucher, setSLTypeVoucher] = useState<any[]>([])

  const [dataFilter, setDataFilter] = useState("")
  const [activeKey, setActiveKey] = useState<string>("2")


  const {
    voucherTableDetailData,
    setVoucherTableDetailData,
    getVoucherList,
  } = useVoucherDetail(id, activeKey, dataFilter)

  const gInfoVoucher = async () => {
    const result = await getInfoVoucher(Number(id))
    if (result?.status) {
      setInfoVoucher(result.data)
    } else {
      pushToast(result?.message, "warning")
      navigate(-1)

    }
  }

  const handleCloneVoucher = () => {
    if (!infoVoucher) return


    navigate('/marketing/vouchers-management/add', {
      state: {
        cloneData: {
          title: `${infoVoucher.title}-Copy`,
          description: infoVoucher.description,
          issuedUnitId: infoVoucher.issuedUnit?.id,
          appliedUnitIds: infoVoucher.appliedUnitIds,
          appliedBrandIds: infoVoucher.appliedBrandIds,
          appliedActivityTypeIds: infoVoucher.appliedActivityTypeIds,
          approvedUnitId: infoVoucher.approvedUnit?.id,
          typeVoucher: infoVoucher.typeVoucherId,
          voucherType: infoVoucher.type,
          voucherCustomers: infoVoucher.voucherCustomers,
          voucherGroupCustomers: infoVoucher.voucherGroupCustomers,
          quantity: infoVoucher.quantity,
          role: infoVoucher.percentDecrease ? 1 : 0,
          percentDecrease: infoVoucher.percentDecrease,
          reducedAmount: infoVoucher.reducedAmount,
          orderValueMin: infoVoucher.orderValueMin,
          reducedAmountMaximum: infoVoucher.reducedAmountMaximum,
          termsOfUse: infoVoucher.termsOfUse,
          dateStart: infoVoucher.dateStart,
          timeStart: infoVoucher.timeStart,
          dateEnd: infoVoucher.dateEnd,
          timeEnd: infoVoucher.timeEnd,
        },
      },
    })
  }

  const gSLTypeVoucher = async () => {
    pushLoading(true)
    const result = await getCLTypeVoucher()
    if (result?.status) {
      setSLTypeVoucher(fommatSelectOptionTitle(result.data))
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }


  const editStatusVoucher = async (status?: number, approvalNote?: string) => {

    
    pushLoading(true)

    const result = await updateStatusVoucher(Number(id), status, approvalNote)
    if (result?.status) {
      // setInfoVoucher(result.data)
      gInfoVoucher()
      getVoucherList()
      pushToast(result?.message, "success")

    } else {
      pushToast(result?.message, "warning")

    }
    pushLoading(false)

  }

  const onChangeActive = useThrottle(async (value: boolean) => {
    const start = dayjs(
      `${infoVoucher?.dateStart} ${infoVoucher?.timeStart}`,
      "DD/MM/YYYY HH:mm"
    );

    const end = dayjs(
      `${infoVoucher?.dateEnd} ${infoVoucher?.timeEnd}`,
      "DD/MM/YYYY HH:mm"
    );

    const now = dayjs();
    switch (infoVoucher?.status) {
      case VoucherDetailStatusEnum.ACTIVE:
        editStatusVoucher(VoucherAction.PAUSE)
        break;
      case VoucherDetailStatusEnum.PAUSED:
        if (start.isBefore(now) && end.isAfter(now)) {
          editStatusVoucher(VoucherAction.RESUME);
        }
        break;

      default:
        break;
    }
  }, 2000)


  const onFinish: FormProps["onFinish"] = async (values) => {
    const { state, approvalNote } = values
    editStatusVoucher(state, approvalNote)

    setModalShow(false)
  }


  const onSubmitForm = () => {
    formRef.current?.submit()

  }



  useEffect(() => {
    if (id) {
      gInfoVoucher()
      gSLTypeVoucher()
    } else {
      navigate(-1)
    }
  }, [navigate, id])

  return (
    <Layout contentClassName="voucher-detail-content">
      <Modal
        title="Duyệt chương trình voucher"
        open={isModalShow}
        centered
        confirmLoading={confirmLoading}
        footer={[
          <Button type="text" onClick={() => setModalShow(false)}>
            Huỷ
          </Button>,
          <Button key="submit" type="primary" loading={confirmLoading} onClick={onSubmitForm} className="rs-button">
            Lưu
          </Button>,
        ]}
        className="rs-modal w-400"
        onCancel={() => setModalShow(false)}
      >
        <Form form={form} ref={formRef} name="basic" autoComplete="off" className="rs-form voucher-update-form" onFinish={onFinish} layout='vertical'>
          <Form.Item
            name="state"
            rules={[{ required: true, message: 'Vui lòng chọn trạng thái!' }]}
            label="Trạng thái"
            layout='vertical'
          >
            <Select
              className='custom-page-css border rounded overflow-hidden'
              placeholder='Đồng ý/ Từ chối'
              options={[
                { value: VoucherAction.APPROVE, label: 'Đồng ý' },
                { value: VoucherAction.REJECT, label: 'Từ chối' },
              ]}
            />
          </Form.Item>
          <Form.Item
            name="approvalNote"
            label="Ghi chú phê duyệt"
            layout='vertical'
          >
            <TextArea
              className='custom-input-css custom-page-css border '
              placeholder='Ghi chú phê duyệt'
            />
          </Form.Item>

          {
            (dayjs(infoVoucher?.dateStart).isAfter(dayjs()) || state !== VoucherAction.APPROVE)
              ?
              ''
              :
              <span
                className='text-F5222D text-sm'
              >
                Ngày bắt đầu dự kiến của voucher là {formatDateToDMYGroup(infoVoucher?.dateStart)} đã qua. Chương trình sẽ có hiệu lực ngay lập tức sau khi bạn phê duyệt voucher.
              </span>

          }

        </Form>
      </Modal>
      <BreadcrumbBlock
        items={[
          { title: <Link to="/">THACO AUTO CRM</Link>, },
          { title: 'Marketing', },
          { title: 'Quản lý Voucher', },
          { title: 'Chi tiết Voucher', },
        ]}
        title='Chi tiết Voucher'
        backLink='/marketing/vouchers-management'
        firstPage={firstPage}
        idBackLink={idCustomer}

        actions={(() => {
          switch (infoVoucher?.status) {
            case VoucherDetailStatusEnum.AWAITING_APPROVAL:
              return (
                <>
                  {/* <Button
                    icon={<CloseCircleOutlined />}
                    style={{ background: '#FFF1F0', borderColor: '#F5222D', color: '#F5222D' }}
                  >
                    Từ chối
                  </Button> */}
                  <Button
                    style={{ background: '#096DD9', borderColor: '#1890FF', color: '#FFFFFF' }}
                    onClick={() => setModalShow(true)}
                    disabled={!approve}
                  >
                    Phê duyệt
                  </Button>
                </>
              );
            case VoucherDetailStatusEnum.DRAFT:
              return (
                <>
                  <Button
                    style={{ background: '#FFFFFF', borderColor: '#096DD9', color: '#096DD9' }}
                    onClick={() => navigate('/marketing/vouchers-management/edit', { state: { id: infoVoucher.id } })}
                  >
                    Sửa
                  </Button>
                  <Button
                    style={{ background: '#096DD9', borderColor: '#1890FF', color: '#FFFFFF' }}
                    onClick={() => editStatusVoucher(VoucherAction.SUBMIT)}
                  >
                    Gửi duyệt
                  </Button>
                </>
              );
            default:
              return (
                <>
                  {/* <Button
                    icon={<CloseCircleOutlined />}
                    style={{ background: '#FFF1F0', borderColor: '#F5222D', color: '#F5222D' }}
                  >
                    Từ chối
                  </Button> */}
                  <Button
                    style={{ background: '#096DD9', borderColor: '#1890FF', color: '#FFFFFF' }}
                    onClick={handleCloneVoucher}
                    disabled={!infoVoucher}
                  >
                    Nhân bản
                  </Button>
                </>
              )
          }
        })()}
      />

      < VoucherDetailCard
        infoVoucher={infoVoucher}
        sLTypeVoucher={sLTypeVoucher}
        onChangeActive={onChangeActive}
      />

      <VoucherDetailTable
        id={Number(id)}
        infoVoucher={infoVoucher}
        activeKey={activeKey}
        dataFilter={dataFilter}
        voucherTableDetailData={voucherTableDetailData}
        setVoucherTableDetailData={setVoucherTableDetailData}

        setActiveKey={setActiveKey}
        setDataFilter={setDataFilter}
        gInfoVoucher={gInfoVoucher}
        reloadVoucherList={getVoucherList}
      />
    </Layout >
  );
}

export default VoucherDetail;
